import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import styled from "styled-components";
import OccurrenceIcon from "./OccurrenceIcon";

const TypeOption = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const TypeLabel = styled.span`
  font-size: 16px;
  line-height: 1.35;
  letter-spacing: 0.01em;
`;

export default function OccurrenceTypeOption({ occurrence, fallbackColor }) {
  if (!occurrence) {
    return null;
  }
  return (
    <TypeOption>
      <OccurrenceIcon occurrence={occurrence} fallbackColor={fallbackColor} />
      <TypeLabel>{occurrence.name}</TypeLabel>
    </TypeOption>
  );
}

OccurrenceTypeOption.propTypes = {
  occurrence: PropTypes.object,
  fallbackColor: PropTypes.string
};

OccurrenceTypeOption.defaultProps = {
  occurrence: null,
  fallbackColor: undefined
};
